import { Controller } from "@hotwired/stimulus"

// This controller is no longer needed because tooltips now use DaisyUI classes.
// Keep an empty controller to avoid breaking data-controller references in other contexts.
export default class extends Controller {}